import { createClient } from '@supabase/supabase-js'

// These will come from environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to .env')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false // We don't need auth sessions for job listings
  }
})

// Database service functions
export const jobsService = {
  // Get all active jobs with optional filtering
  async getJobs(filters = {}) {
    let query = supabase
      .from('public_jobs')
      .select('*')

    // Apply filters
    if (filters.category) {
      query = query.eq('category', filters.category)
    }
    if (filters.location) {
      query = query.ilike('location', `%${filters.location}%`)
    }
    if (filters.job_type) {
      query = query.eq('job_type', filters.job_type)
    }
    if (filters.search) {
      query = query.or(`title.ilike.%${filters.search}%,location.ilike.%${filters.search}%,category.ilike.%${filters.search}%`)
    }
    if (filters.featured) {
      query = query.eq('is_featured', true)
    }

    // Apply sorting
    const sortBy = filters.sort_by || 'posted_date'
    const sortOrder = filters.sort_order || 'desc'
    query = query.order(sortBy, { ascending: sortOrder === 'asc' })

    // Apply pagination
    if (filters.limit) {
      query = query.limit(filters.limit)
    }
    if (filters.offset) {
      query = query.range(filters.offset, filters.offset + (filters.limit || 10) - 1)
    }

    const { data, error } = await query

    if (error) {
      throw new Error(`Error fetching jobs: ${error.message}`)
    }

    return data || []
  },

  // Get job categories
  async getCategories() {
    const { data, error } = await supabase
      .from('job_categories')
      .select('*')
      .eq('is_active', true)
      .order('sort_order')

    if (error) {
      throw new Error(`Error fetching categories: ${error.message}`)
    }

    return data || []
  },

  // Get job by slug for individual job pages
  async getJobBySlug(slug) {
    const { data, error } = await supabase
      .from('public_jobs')
      .select('*')
      .eq('slug', slug)
      .single()

    if (error) {
      throw new Error(`Error fetching job: ${error.message}`)
    }

    return data
  }
}
